let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jbZWq")).then(() => parcelRequire('kJN9s'));